<template>
  <input id="phone" type="tel" v-model="formattedPhone" @input="formatPhone" placeholder="+7 ___ ___-__-__"
    maxlength="18" />
</template>

<script>
export default {
  name: "PhoneInput",
  props: {
    modelValue: String, // Поддержка v-model
  },
  data() {
    return {
      phone: this.modelValue, // Начальное значение
    };
  },
  computed: {
    formattedPhone: {
      get() {
        return this.phone;
      },
      set(value) {
        this.phone = value;
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    formatPhone(event) {
      let numbers = event.target.value.replace(/\D/g, ""); // Оставляем только цифры

      // Убираем 8 или +7 в начале
      if (numbers.startsWith("8")) {
        numbers = "7" + numbers.slice(1);
      } else if (numbers.startsWith("7")) {
        numbers = "7" + numbers.slice(1);
      } else {
        numbers = "7" + numbers;
      }

      // Ограничиваем длину номера (10 цифр после 7)
      numbers = numbers.slice(0, 11);

      // Форматируем
      let formatted = "+7 ";
      if (numbers.length > 1) formatted += numbers.slice(1, 4);
      if (numbers.length > 4) formatted += " " + numbers.slice(4, 7);
      if (numbers.length > 7) formatted += "-" + numbers.slice(7, 9);
      if (numbers.length > 9) formatted += "-" + numbers.slice(9, 11);

      this.formattedPhone = formatted;
    },
  },
  watch: {
    modelValue(newValue) {
      this.phone = newValue || "+7 ";
    },
  },
};
</script>